import React from "react";

const IconMessage = () => (
  <i className="material-icons v-mid">chat_bubble_outline</i>
);

export default IconMessage;
